import script from "./FoodItemDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./FoodItemDescription.vue?vue&type=script&setup=true&lang=js"

import "./FoodItemDescription.vue?vue&type=style&index=0&id=767cedda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-767cedda"]])

export default __exports__